<template>
  <div>
    <filter-slot
      :filter="filters"
      :filterPrincipal="filterPrincipal"
      :paginate="paginate"
      @reload="$refs['ref-table-rrhh-aumento-sueldo'].refresh()"
    >
      <template #buttons>
        <b-button
          variant="info"
          v-b-tooltip.hover.top="$t('Download Excel')"
          @click="exportToExcel"
        >
          <feather-icon icon="FileTextIcon" /> Excel
        </b-button>
      </template>

      <template #table>
        <b-table
          ref="ref-table-rrhh-aumento-sueldo"
          :per-page="paginate.perPage"
          :current-page="paginate.currentPage"
          sticky-header="50vh"
          small
          class="position-relative font-small-3"
          table-class="text-nowrap"
          :busy.sync="isBusy"
          :items="myProvider"
          :fields="showFields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          primary-key="id"
          :empty-text="$t('No matching records found')"
          show-empty
        >
          <template #table-busy>
            <b-skeleton-table
              :headers="fields"
              :rows="paginate.perPage"
              :columns="fields.length"
              :table-props="{ bordered: true, striped: true }"
            />
          </template>

          <template #cell(employee_id)="data">
            <router-link
              target="_blank"
              :class="[textLink]"
              :to="{
                name: 'rrhh-employees-information',
                params: { id: data.item.employee_id },
              }"
            >
              {{ data.item.full_name | capitalize }} </router-link
            ><br />
          </template>
          <template #cell(status)="data">
            <b-badge :variant="getStatusVariant(data.item.estado)">
              <span class="text-uppercase">
                {{ data.item.estado }}
              </span>
            </b-badge>
          </template>
          <template #cell(sueldo_base_anterior)="data">
            <span class="">
              S/.{{ data.item.sueldo_base_anterior | currency }}
            </span>
          </template>
          <template #cell(bono_anterior)="data">
            <span class=""> S/.{{ data.item.bono_anterior | currency }} </span>
          </template>
          <template #cell(nuevo_sueldo_base)="data">
            <span class="">
              S/.{{ data.item.nuevo_sueldo_base | currency }}
            </span>
          </template>
          <template #cell(nuevo_bono)="data">
            <span class=""> S/.{{ data.item.nuevo_bono | currency }} </span>
          </template>
          <template #cell(fecha_vigencia)="data">
            {{ data.item.fecha_vigencia | myGlobal }}
          </template>
          <template #cell(created_by)="data">
            <span> {{ data.item.user_created | capitalize }} </span><br />
          </template>
          <template #cell(created_at)="data">
            <feather-icon
              icon="CalendarIcon"
              class="text-success"
              size="15"
              style="opacity: 0.7"
            />
            {{ data.item.created_at | myGlobalDay }}
          </template>
          <template #cell(actions)="data">
            <feather-icon
              v-if="data.item.estado == 'pendiente' && isCeo"
              icon="CheckSquareIcon"
              class="cursor-pointer text-success"
              size="17"
              v-b-tooltip.hover.left="$t('Aprobar aumento')"
              @click="openAumentoSueldoModal(data.item, 'revision')"
            />

            <feather-icon
              v-if="data.item.estado == 'pendiente'"
              icon="EditIcon"
              class="cursor-pointer text-warning ml-1"
              size="17"
              v-b-tooltip.hover.left="$t('Modificar aumento')"
              @click="openAumentoSueldoModal(data.item, 'edit')"
            />

            <feather-icon
              v-if="data.item.estado == 'pendiente'"
              icon="Trash2Icon"
              class="cursor-pointer text-danger ml-1"
              size="17"
              v-b-tooltip.hover.left="$t('Anular aumento')"
              @click="anularAumento(data.item)"
            />
          </template>
        </b-table>
      </template>
    </filter-slot>

    <AumentoSueldoModal
      v-if="showAumentoSueldoModal"
      :modalData="modalData"
      @hideModal="showAumentoSueldoModal = false"
      @updated="
        refreshTable();
        showAumentoSueldoModal = false;
      "
    />
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";

/* Data */
import Fields from "@/views/rrhh/views/aumento-sueldo/data/fields.data.js";
import Filters from "@/views/rrhh/views/aumento-sueldo/data/filter.data.js";

/* COMPONENTS */
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

/* Modals */
import AumentoSueldoModal from "@/views/rrhh/views/aumento-sueldo/components/AumentoSueldoModal.vue";

/* Services */
import EmployeeService from "@/views/rrhh/views/employees/services/employee.service.js";
import AumentoSueldoService from "@/views/rrhh/views/aumento-sueldo/services/aumento-sueldo.service.js";

export default {
  components: {
    FilterSlot,
    AumentoSueldoModal,
  },
  props: {
    tab: {
      type: String,
      require: true,
    },
  },
  data() {
    return {
      filters: Filters,
      params: 1,
      fields: Fields,
      isBusy: false,
      sortBy: "",
      sortDesc: true,
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "Search...",
        model: "",
      },
      paginate: {
        from: 0,
        to: 0,
        of: 0,
        perPage: 10,
        currentPage: 1,
      },
      initDateSelect: "",
      modalData: {
        id: null,
      },
      showAumentoSueldoModal: false,
      initDate: moment().startOf("week").add(1, "days").format("YYYY-MM-DD"),
      endDate: moment().endOf("week").add(1, "days").format("YYYY-MM-DD"),
      minDate: new Date(1000, 1, 1),
      maxDate: new Date(2050, 9, 1),
      weekly: "",
      firstCard: {
        title: "Pending Discounts",
        icon: 1,
        total: 0,
        subtitle: "Total",
        color: "primary",
      },
      secondCard: {
        title: "Pending Current Month Discounts",
        icon: 2,
        total: 0,
        subtitle: "Total",
        color: "primary",
      },
    };
  },
  computed: {
    showFields() {
      this.fields.map((row) => (row.visible = true));

      let fieldsVisible = this.fields.filter((item) => item.visible);
      fieldsVisible = fieldsVisible.map((element) => ({
        ...element,
        label: this.$t(element.label),
      }));
      return fieldsVisible;
    },
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
  },
  async created() {
    await Promise.all([
      this.getAreas(),
      //   this.getPendingDiscountsSum(),
    ]);
    this.initDateSelect = this.initDate;
  },
  methods: {
    async exportToExcel(ctx) {
      try {
        let order = 18;
        switch (ctx.sortBy) {
          case "employee_id":
            order = 4;
            break;
          case "created_at":
            order = 18;
            break;
          default:
            order = 18;
            break;
        }
        this.addPreloader();
        const params = {
          page: ctx.currentPage,
          perpage: ctx.perPage,
          order: order,
          orderby: ctx.sortDesc ? "Desc" : "Asc",
          search_txt: this.filterPrincipal.model,
          status: null,
          from: this.filters[0].model,
          to: this.filters[1].model,
          area_id: this.filters[2].model,
          module_id: this.currentUser.modul_id,
        };
        const { data } = await AumentoSueldoService.exportToExcel(params);
        const hora = moment().hour(); // 0 - 23
        const minutos = moment().minute(); // 0 - 59
        const segundos = moment().second(); // 0 - 59

        // Calcular valor numérico total: HH * 3600 + MM * 60 + SS
        const tiempoEnSegundos = hora * 3600 + minutos * 60 + segundos;

        const fileName = `Aumento_sueldo_${moment().format(
          "YYYYMMDD"
        )}_${tiempoEnSegundos}.xlsx`;
        this.forceFileDownload(data, fileName);
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },

    getStatusVariant(status) {
      switch (status) {
        case "pendiente":
          return "light-warning";
        case "aprobado":
          return "light-success";
        case "procesado":
          return "light-success";
        case "rechazado":
          return "light-danger";
        case "anulado":
          return "light-info";
      }
    },
    async myProvider(ctx) {
      try {
        let order = 18;
        switch (ctx.sortBy) {
          case "employee_id":
            order = 4;
            break;
          case "created_at":
            order = 18;
            break;
          default:
            order = 18;
            break;
        }
        this.addPreloader();
        const params = {
          page: ctx.currentPage,
          perpage: ctx.perPage,
          order: order,
          orderby: ctx.sortDesc ? "Desc" : "Asc",
          search_txt: this.filterPrincipal.model,
          status: null,
          from: this.filters[0].model,
          to: this.filters[1].model,
          area_id: this.filters[2].model,
          module_id: this.currentUser.modul_id,
        };
        const { data } = await AumentoSueldoService.index(params);
        this.paginate.from = data.from;
        this.paginate.to = data.to;
        this.paginate.of = data.total;
        this.paginate.perPage = data.per_page;
        this.paginate.currentPage = data.current_page;
        return data.data || [];
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
    async getAreas() {
      try {
        const { data } = await EmployeeService.getAllAreas({
          moduleId: this.currentUser.modul_id,
        });
        this.filters[2].options = data;
      } catch (error) {
        console.log(error);
      }
    },
    solicitarAumentoSueldo() {
      this.modalData.id = null;
      this.modalData.action = null;
      this.showAumentoSueldoModal = true;
    },

    openAumentoSueldoModal(data, action) {
      if (action == "edit" || action == "revision" || action == "anulle") {
        this.modalData.id = data.id;
        this.modalData.action = action;
        this.showAumentoSueldoModal = true;
      }
    },

    async anularAumento(item) {
      try {
        const { isConfirmed } = await this.showConfirmSwal();

        if (!isConfirmed) return;

        this.addPreloader();
        const params = {
          id: item.id,
        };
        const data = await AumentoSueldoService.destroy(params);
        console.log("destroy: ", data);
        this.refreshTable();
      } catch (error) {
      } finally {
        this.removePreloader();
      }
    },

    refreshTable() {
      this.$refs["ref-table-rrhh-aumento-sueldo"].refresh();
    },
  },
  watch: {
    initDateSelect(newVal, oldVal) {
      this.initDate = moment(newVal)
        .startOf("week")
        .add(1, "days")
        .format("YYYY-MM-DD");
      this.endDate = moment(newVal)
        .startOf("week")
        .add(7, "days")
        .format("YYYY-MM-DD");
    },
  },
};
</script>

<style>
.k-datepicker {
  background-color: transparent !important;
  border-width: thin;
  border-style: solid;
  border-color: #ced4da;
}

.k-datepicker span {
  border-width: 0 !important;
  background-color: transparent !important;
}

.k-datepicker:hover {
  background-color: transparent !important;
  border-width: thin;
  border-style: solid;
  border-color: #ced4da;
}

.dark-layout .k-datepicker:hover {
  background-color: transparent !important;
}

.k-state-hover .k-state-focused {
  background-color: transparent !important;
  border-color: transparent !important;
}

.k-widget.form-control .k-input {
  height: 2.5rem !important;
}
</style>
